import { render, staticRenderFns } from "./DriverAppChat.vue?vue&type=template&id=039c6fd6&scoped=true"
import script from "./DriverAppChat.vue?vue&type=script&lang=js"
export * from "./DriverAppChat.vue?vue&type=script&lang=js"
import style0 from "./DriverAppChat.vue?vue&type=style&index=0&id=039c6fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039c6fd6",
  null
  
)

export default component.exports